import { clamp } from "lodash";
import formatPrice from "@/core/helpers/formatPrice";

function DummySlider({ value, min, max }: { value: number; min: number; max: number }) {
  const clampedValue = clamp(value, min, max);
  const percentage = ((clampedValue - min) / (max - min)) * 100;

  return (
    <div className="relative w-full">
      {/* Track */}
      <div className="relative h-1 rounded-full bg-dark-700">
        {/* Fill */}
        <div
          className="absolute left-0 top-0 h-full rounded-full"
          style={{
            width: `${percentage}%`,
            background: "linear-gradient(to right, #186D27, #21A038)",
          }}
        />

        {/* Thumb */}
        <div
          className="absolute top-1/2 transform w-[3px] h-[8px] bg-sbank -translate-x-1/2 -translate-y-1/2"
          style={{
            left: `${percentage}%`,
          }}
        />
      </div>
    </div>
  );
}

type LimitSliderProps = {
  min: number;
  max: number;
  value: number;
};

export function LimitSlider({ min, max, value }: LimitSliderProps) {
  return (
    <div>
      <DummySlider value={value} min={min} max={max} />

      <div className="flex justify-between mt-2 text-14">
        <div className="text-sbank">{formatPrice(value)} ₽</div>
        <div>{formatPrice(max)} ₽</div>
      </div>
    </div>
  );
}
